export default "__VITE_PUBLIC_ASSET__78178b23__"